import React from "react";
import { Reveal } from "../shared/Reveal";

export default function AudioSection() {
  return (
    <section id="audio" className="audio">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">AUDIO LIBRARY</Reveal>
        <Reveal className="h2" tag="div">Listen to a Sample of <span className="g">Our Audio Library</span></Reveal>
        <Reveal className="lead" tag="p">Insight you can listen to. A growing library exploring energy, intelligence and the future of buildings.</Reveal>
        <Reveal className="audiocard" tag="div">
          <div className="disc" onClick={(e) => { const a = e.currentTarget.parentElement.querySelector("audio"); a.paused ? a.play() : a.pause(); }} data-testid="audio-disc">
            <svg viewBox="0 0 24 24" fill="#E5A13B"><path d="M8 5v14l11-7z" /></svg>
          </div>
          <div className="ac">
            <div className="tag">1 · TRACK</div>
            <h3>The Evolution of Energy Independence</h3>
            <p>A welcome from Michael. Thirty years of energy independence work — and why the foundation is no longer generation or storage, but intelligence.</p>
            <div className="runtime">RUNNING TIME · 3 MIN 13 SEC</div>
            <audio controls preload="none" data-testid="audio-player" src="/audio/welcome.mp3" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
